import React from 'react';
import Form from '../common/form';
import { injectIntl } from 'react-intl';
import { azuriranjeOpcineSchema } from './opcine-validacije';
import intl from '../../services/intl-service';
import { opcinaService } from '../../services/m-o-r-service';
import { toastError, toastSuccess } from '../../services/toast-service';
import CustomAlertNoForm from './../common/custom-alert-no-form';
import InfoVrijemeUpisa from './../common/info-vrijeme-upisa';
import { DataLoader } from './../../services/data-loader-service';
import CancelButton from '../common/cancel-button';

//Debounce: https://stackoverflow.com/questions/23123138/perform-debounce-in-react-js

class UrediOpcinu extends Form {
   state = {
      validationData: {
         sifraOpcine: '',
         nazivOpcine: ''
      },
      errors: {},
      datumUpisa: '',
      vrijemeUpisa: '',
      showConfirm: false
   };

   schema = azuriranjeOpcineSchema;

   componentDidMount() {
      const { odabranaOpcina } = this.props;
      if (!odabranaOpcina) return;

      const validationData = { ...this.state.validationData };
      const { sifraOpcine, nazivOpcine } = odabranaOpcina;

      validationData.sifraOpcine = sifraOpcine;
      validationData.nazivOpcine = nazivOpcine;

      this.setState({ validationData });
   }

   doSubmit = async () => {
      this.setState({ showConfirm: true });
   };

   doSubmitOnConfirm = async () => {
      const { sifraOpcine, nazivOpcine } = this.state.validationData;
      const azuriraniPodaci = { sifraOpcine, nazivOpcine, operaterUpisa: 14 };
      const { data: response } = await opcinaService.addOrUpdate(
         azuriraniPodaci
      );

      if (response.isSuccess === 1) {
         toastSuccess();
         this.props.onSubmit();
         this.setState({ showConfirm: false });
      } else toastError();

      this.setState({ showConfirm: false });
   };

   onDataLoad = (response) => {
      const validationData = { ...this.state.validationData };
      const { nazivOpcine, datumUpisa, vrijemeUpisa } = response;
      validationData.nazivOpcine = nazivOpcine;

      this.setState({ validationData, datumUpisa, vrijemeUpisa });
   };

   ucitajPodatkeOpcine = (sifraOpcine) => {
      DataLoader(opcinaService.get, [sifraOpcine], this.onDataLoad);
   };

   handleSifraOpcineChange = async ({ target: input }) => {
      if (isNaN(input.value)) return;

      const sifraOpcine = Number(input.value);
      if (sifraOpcine >= 1 && sifraOpcine <= 9500)
         this.ucitajPodatkeOpcine(sifraOpcine);
   };

   render() {
      const { validationData, showConfirm, datumUpisa, vrijemeUpisa } =
         this.state;
      const { nazivOpcine } = validationData;

      return (
         <>
            <CustomAlertNoForm
               showCondition={showConfirm}
               onCancel={() => this.setState({ showConfirm: false })}
               onOk={() => this.doSubmitOnConfirm()}
            >
               <div>
                  {intl.getTranslate('opcina.confirmMessage')}{' '}
                  <span className='confirm-highlight'>{nazivOpcine}</span>?
               </div>
            </CustomAlertNoForm>
            <form onSubmit={this.handleFormSubmit} className='form'>
               <div className='uredi-opcinu'>
                  <div className='row'>
                     <div className='col-6'>
                        {this.renderTranslateInput(
                           'sifraOpcine',
                           'opcina',
                           this.handleSifraOpcineChange,
                           true,
                           null,
                           { disabled: 'disabled' }
                        )}
                     </div>
                  </div>
                  <div className='row'>
                     <div className='col-6'>
                        {this.renderTranslateInput('nazivOpcine', 'opcina')}
                     </div>
                  </div>

                  <hr />

                  <InfoVrijemeUpisa
                     datumUpisa={datumUpisa}
                     vrijemeUpisa={vrijemeUpisa}
                  />

                  {this.renderSubmitButton(
                     `${intl.getTranslate('common.edit')}`
                  )}
                  <CancelButton onClick={this.props.onCancel} />
               </div>
            </form>
         </>
      );
   }
}

export default injectIntl(UrediOpcinu);
